<template>
  <button @click="exportCreditDeposit" class="btn btn-sm btn-info mr-1 mb-1">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount" :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportCreditDeposit: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 1000;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/credit-deposit/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            client: item.client && item.client.companyName ? item.client.companyName : '',
            domain: item.client && item.client.domain ? item.client.domain : '',
            amount: item.amount,
            content: item.content ? item.content : '',
            method: item.method,
            ref: item.ref ? item.ref : '',
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            confirmTime: item.confirmTime ? moment(item.confirmTime).format('DD/MM/YYYY HH:mm:ss') : '',
            invoiceNo: item.invoice && item.invoice.no ? item.invoice.no : '',
          };
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'credit-deposit.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      let cols = [
        {header: this.$t('clientName'), key: 'client', width: 15},
        {header: this.$t('domain'), key: 'domain', width: 15},
        {header: this.$t('amount'), key: 'amount', width: 15},
        {header: this.$t('content'), key: 'content', width: 15},
        {header: this.$t('method'), key: 'method', width: 15},
        {header: this.$t('ref'), key: 'ref', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 15},
        {header: this.$t('confirmTime'), key: 'confirmTime', width: 15},
        {header: this.$t('invoiceNo'), key: 'invoiceNo', width: 20},
      ];
      sheet.columns = cols;
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      vi: {
        clientName: 'Tên khách hàng',
        amount: 'Số tiền',
        content: 'Nội dung',
        method: 'Phương thức',
        ref: 'Mã ref',
        createTime: 'Tạo lúc',
        confirmTime: 'Xác nhận lúc',
        export: 'Xuất dữ liệu',
        invoiceNo: 'Số hóa đơn'
      },
      en: {
        clientName: 'Client name',
        amount: 'Amount',
        content: 'Content',
        method: 'Method',
        ref: 'Ref',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        export: 'Export',
        invoiceNo: 'Invoice no'
      },
    }
  }
}
</script>
